export const notificationsTracker = {
  actions: {
    clickedOnANotification: 'Notificações: Clicou em uma notificação',
    readAllNotifications: 'Notificações: Marcou tudo como lido',
    closeNotifications: 'Notificações: Clicou para fechar as notificações',
    openNotifications: 'Abrir Notificações',
  },
}
